import {rootActions, useAppDispatch, useAppSelector} from "../../data-services/store";
import QuestionMarkIcon from "../../../../../ui/svg/common/question-mark";
import {Popup} from "../../../../../ui/popup/popup";
import {sendGAEvent} from "../../../../../domain/marketing/gtm-provider";

/**
 * the entry point
 */
const PRDNeedHelpDeciding: React.FC = () => {
    const dispatch = useAppDispatch();
    const IsNeedHelpDecidingPopupShown = useAppSelector((store) => store.IsNeedHelpDecidingPopupShown);
    const pathArr = window.location.pathname?.split("/");
    const isPlugins = pathArr && pathArr[1] === 'plugins';

    const openPopup = () => {
        dispatch(
            rootActions.main({
                IsNeedHelpDecidingPopupShown: true
            })
        );

        sendGAEvent('Click','need help deciding');
    };

    const closePopup = () => {
        dispatch(
            rootActions.main({
                IsNeedHelpDecidingPopupShown: false
            })
        );
    };
    return (
        <>
        <div className="flex flex-row justify-center w-88 lg:w-100 mt-5 cursor-pointer" onClick={ openPopup }>
            <div>Need help deciding</div>
            <QuestionMarkIcon width={"24px"} circleColor={"white"} markColor={"black"} classes="cursor-pointer pl-1"
                              title="QuestionMark"/>
        </div>
        {IsNeedHelpDecidingPopupShown && <Popup classes="w-fit" close={ closePopup }>
            <div style={{maxWidth: '750px'}}
                className="prd-need-help-deciding-popup mt-12 mb-4 flex flex-col justify-center items-center w-full h-full text-center text-gray-700">
                <table className="waves-table" cellPadding="8" cellSpacing="0" style={{tableLayout: 'auto'}}>
                    <thead className="bg-gray-100 text-gray-700">
                    <tr>
                        <th style={{ padding: '0.75rem 1rem' }} className="font-semibold"></th>
                        <th style={{ padding: '0.75rem 1rem' }} className="font-semibold text-gray-700">Add to Cart</th>
                        <th style={{ padding: '0.75rem 1rem' }} className="font-semibold text-gray-700">Subscribe</th>
                    </tr>
                    </thead>

                    <colgroup>
                        <col className="w-24 lg:w-32 whitespace-nowrap"/>
                        <col/>
                        <col/>
                    </colgroup>
                    <tbody className="text-left divide-y divide-gray-200 text-xs md:text-tiny">
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">Plugins</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Purchase plugins one-by-one or in bundles</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Subscribe to over 240 plugins in Waves Ultimate, over 110 plugins
                            in Waves Essential
                        </td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">Payment</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">One-time purchase</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Monthly or annual subscription</td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">Updates</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">1 free year of updates from the moment you purchase. Further
                            version updates with an active Waves Update Plan.
                        </td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Updates included automatically with your subscription: easy
                            one-click plugin updates from Waves Central.
                        </td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">New plugins</td>
                        {
                            !isPlugins &&
                             <td  style={{ padding: '0.75rem 1rem' }} className="">
                                Select bundles with an active Waves Update Plan may get new
                                plugins added
                            </td>
                        }
                        {
                            isPlugins &&
                             <td  style={{ padding: '0.75rem 1rem' }} className="text-center"><span className="text-red">X</span>
                            </td>
                        }
                         <td  style={{ padding: '0.75rem 1rem' }} className="">New plugins added for free (select plugins added to Essential,
                            most plugins added to Ultimate)
                        </td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">StudioVerse plugin chains</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Use StudioVerse chains that include the specific plugins you own
                        </td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Use a vast number of StudioVerse chains that include your Ultimate
                            or Essential plugins
                        </td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">Waves Stream</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="text-center"><span className="text-red">X</span></td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Free access to Waves Stream remote audio collaboration service
                        </td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">Free Courses</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="text-center"><span className="text-red">X</span></td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Access dozens of hours of premium mixing courses free of charge
                        </td>
                    </tr>
                    <tr>
                         <td  style={{ padding: '0.75rem 1rem' }} className="font-medium text-gray-800">Gemstones</td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="text-center"><span className="text-red">X</span></td>
                         <td  style={{ padding: '0.75rem 1rem' }} className="">Gemstones included</td>
                    </tr>
                    </tbody>
                </table>

            </div>

        </Popup>}
        </>
    )
};

export default PRDNeedHelpDeciding;